import React, { useState } from 'react';
import { PolicyModal } from './PolicyModal';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const privacyContent = <div className="space-y-6 text-slate-700" data-id="element-20">
      <p className="text-sm text-slate-500" data-id="element-21">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>

      <section data-id="element-22">
        <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-23">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-24">
          Al adquirir "Hormonas en Calma (45+)", recopilamos únicamente la
          información necesaria para procesar tu compra y entregarte el producto
          digital:
        </p>
        <ul className="list-disc pl-6 mt-2 space-y-1" data-id="element-25">
          <li data-id="element-26">Nombre y dirección de correo electrónico</li>
          <li data-id="element-27">
            Información de pago (procesada de forma segura por nuestro proveedor
            de pagos)
          </li>
          <li data-id="element-28">Dirección IP y datos de navegación básicos</li>
        </ul>
      </section>

      <section data-id="element-29">
        <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-30">
          2. Uso de la Información
        </h3>
        <p data-id="element-31">Utilizamos tu información para:</p>
        <ul className="list-disc pl-6 mt-2 space-y-1" data-id="element-32">
          <li data-id="element-33">Procesar y completar tu compra</li>
          <li data-id="element-34">Enviarte el acceso al PDF descargable</li>
          <li data-id="element-35">Proporcionar soporte al cliente si lo necesitas</li>
          <li data-id="element-36">
            Enviar actualizaciones importantes sobre el producto (opcional)
          </li>
        </ul>
      </section>

      <section data-id="element-37">
        <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-38">
          3. Protección de Datos
        </h3>
        <p data-id="element-39">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger tu información personal contra acceso no autorizado, pérdida
          o alteración. Todos los pagos se procesan a través de plataformas
          seguras certificadas.
        </p>
      </section>

      <section data-id="element-40">
        <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-41">
          4. Compartir Información
        </h3>
        <p data-id="element-42">
          No vendemos, alquilamos ni compartimos tu información personal con
          terceros, excepto cuando sea necesario para procesar tu pago
          (proveedores de servicios de pago) o cuando lo requiera la ley.
        </p>
      </section>

      <section data-id="element-43">
        <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-44">5. Cookies</h3>
        <p data-id="element-45">
          Utilizamos cookies esenciales para el funcionamiento del sitio web y
          para mejorar tu experiencia de navegación. Puedes configurar tu
          navegador para rechazar cookies, aunque esto puede afectar algunas
          funcionalidades.
        </p>
      </section>

      <section data-id="element-46">
        <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-47">
          6. Tus Derechos
        </h3>
        <p data-id="element-48">Tienes derecho a:</p>
        <ul className="list-disc pl-6 mt-2 space-y-1" data-id="element-49">
          <li data-id="element-50">Acceder a tu información personal</li>
          <li data-id="element-51">Solicitar corrección de datos inexactos</li>
          <li data-id="element-52">Solicitar la eliminación de tus datos</li>
          <li data-id="element-53">Oponerte al procesamiento de tus datos</li>
          <li data-id="element-54">Retirar tu consentimiento en cualquier momento</li>
        </ul>
      </section>

      <section data-id="element-55">
        <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-56">
          7. Cambios a esta Política
        </h3>
        <p data-id="element-57">
          Podemos actualizar esta política de privacidad ocasionalmente. Te
          notificaremos sobre cambios significativos publicando la nueva
          política en esta página con una fecha de actualización revisada.
        </p>
      </section>
    </div>;
  const termsContent = <div className="space-y-6 text-slate-700" data-id="element-58">
      <p className="text-sm text-slate-500" data-id="element-59">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>

      <section data-id="element-60">
        <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-61">
          1. Aceptación de Términos
        </h3>
        <p data-id="element-62">
          Al adquirir "Hormonas en Calma (45+)", aceptas estos términos y
          condiciones en su totalidad. Si no estás de acuerdo con alguna parte
          de estos términos, no debes realizar la compra.
        </p>
      </section>

      <section data-id="element-63">
        <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-64">
          2. Descripción del Producto
        </h3>
        <p data-id="element-65">
          "Hormonas en Calma (45+)" es una guía digital en formato PDF diseñada
          para proporcionar información y estrategias sobre regulación del sueño
          y manejo de ansiedad nocturna. El producto incluye:
        </p>
        <ul className="list-disc pl-6 mt-2 space-y-1" data-id="element-66">
          <li data-id="element-67">Guía completa del Protocolo 10-3-1</li>
          <li data-id="element-68">Plan de 21 días con ejercicios prácticos</li>
          <li data-id="element-69">Recursos y materiales de apoyo</li>
        </ul>
      </section>

      <section data-id="element-70">
        <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-71">
          3. Descargo de Responsabilidad Médica
        </h3>
        <p className="font-semibold text-slate-900" data-id="element-72">
          IMPORTANTE: Este producto NO sustituye el consejo, diagnóstico o
          tratamiento médico profesional.
        </p>
        <p className="mt-2" data-id="element-73">
          El contenido de esta guía es solo para fines informativos y
          educativos. No debe utilizarse como sustituto de la consulta con un
          profesional de la salud calificado. Si experimentas síntomas severos o
          persistentes, consulta con tu médico.
        </p>
      </section>

      <section data-id="element-74">
        <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-75">
          4. Licencia de Uso
        </h3>
        <p data-id="element-76">
          Al comprar este producto, recibes una licencia personal, no
          transferible y no exclusiva para usar el material. Está prohibido:
        </p>
        <ul className="list-disc pl-6 mt-2 space-y-1" data-id="element-77">
          <li data-id="element-78">Compartir, distribuir o revender el contenido</li>
          <li data-id="element-79">Modificar o crear obras derivadas sin autorización</li>
          <li data-id="element-80">Usar el contenido con fines comerciales</li>
          <li data-id="element-81">Eliminar marcas de derechos de autor o propiedad</li>
        </ul>
      </section>

      <section data-id="element-82">
        <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-83">
          5. Política de Reembolso
        </h3>
        <p data-id="element-84">
          Debido a la naturaleza digital del producto y el acceso inmediato al
          contenido completo, todas las ventas son finales. No ofrecemos
          reembolsos una vez que el producto ha sido descargado o accedido.
        </p>
        <p className="mt-2" data-id="element-85">
          Si experimentas problemas técnicos con la descarga o acceso al
          producto, contáctanos y te ayudaremos a resolverlo.
        </p>
      </section>

      <section data-id="element-86">
        <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-87">
          6. Resultados No Garantizados
        </h3>
        <p data-id="element-88">
          Los resultados individuales pueden variar. No garantizamos resultados
          específicos del uso de esta guía. El éxito depende de múltiples
          factores, incluyendo tu compromiso con la práctica, condiciones de
          salud individuales y otros factores personales.
        </p>
      </section>

      <section data-id="element-89">
        <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-90">
          7. Limitación de Responsabilidad
        </h3>
        <p data-id="element-91">
          En la máxima medida permitida por la ley, no seremos responsables de
          ningún daño directo, indirecto, incidental, especial o consecuente que
          resulte del uso o la incapacidad de usar este producto.
        </p>
      </section>

      <section data-id="element-92">
        <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-93">
          8. Propiedad Intelectual
        </h3>
        <p data-id="element-94">
          Todo el contenido, incluyendo texto, gráficos, logos e imágenes, es
          propiedad exclusiva y está protegido por leyes de derechos de autor.
          El uso no autorizado puede resultar en acciones legales.
        </p>
      </section>

      <section data-id="element-95">
        <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-96">
          9. Modificaciones
        </h3>
        <p data-id="element-97">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Los cambios entrarán en vigor inmediatamente después de su
          publicación. Tu uso continuado del producto después de los cambios
          constituye tu aceptación de los nuevos términos.
        </p>
      </section>

      <section data-id="element-98">
        <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-99">
          10. Ley Aplicable
        </h3>
        <p data-id="element-100">
          Estos términos se rigen por las leyes aplicables sin considerar
          conflictos de disposiciones legales. Cualquier disputa se resolverá en
          los tribunales competentes.
        </p>
      </section>
    </div>;
  return <>
      <footer className="bg-slate-50 border-t border-slate-100 py-12 px-4" data-id="element-101">
        <div className="max-w-4xl mx-auto" data-id="element-102">
          <div className="text-center space-y-4" data-id="element-103">
            <p className="text-slate-400 text-sm" data-id="element-104">
              © {new Date().getFullYear()} Hormonas en Calma. Todos los
              derechos reservados.
            </p>
            <p className="text-slate-500 text-sm" data-id="element-105">
              Este producto no sustituye el consejo médico profesional.
            </p>

            <div className="flex items-center justify-center gap-6 pt-2" data-id="element-106">
              <button onClick={() => setShowPrivacy(true)} className="text-[#0d9488] hover:text-[#0f766e] text-sm font-medium transition-colors underline underline-offset-4" data-id="element-107">
                Política de Privacidad
              </button>
              <span className="text-slate-300" data-id="element-108">•</span>
              <button onClick={() => setShowTerms(true)} className="text-[#0d9488] hover:text-[#0f766e] text-sm font-medium transition-colors underline underline-offset-4" data-id="element-109">
                Términos y Condiciones
              </button>
            </div>
          </div>
        </div>
      </footer>

      <PolicyModal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" content={privacyContent} data-id="element-110" />

      <PolicyModal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" content={termsContent} data-id="element-111" />
    </>;
}